import { render, staticRenderFns } from "./Game2048.vue?vue&type=template&id=4c034402&"
import script from "./Game2048.vue?vue&type=script&lang=js&"
export * from "./Game2048.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Game2048.vue"
export default component.exports